import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { ConfigObj } from '../entities/config-entity';
import { namespace as appStore, actionTypes } from '../store/modules/app-store';

const AppStore = namespace(appStore);

@Component
export default class AppMixin extends Vue {
	@AppStore.Getter appLoading!: Record<string, boolean>[];
	@AppStore.Getter loadersMap!: Record<string, boolean>;
	@AppStore.Getter('config') appCfg!: ConfigObj;
	@AppStore.Getter vars!: ConfigObj;
	@AppStore.Action(actionTypes.GET_REQUEST) getRequest!: (...args: any) => Promise<any>;
	@AppStore.Action(actionTypes.POST_REQUEST) postRequest!: (...args: any) => Promise<any>;
	@AppStore.Action(actionTypes.PUT_REQUEST) putRequest!: (...args: any) => Promise<any>;
	@AppStore.Action(actionTypes.DELETE_REQUEST) deleteRequest!: (...args: any) => Promise<any>;
	@AppStore.Action(actionTypes.SET_USER_LOCALE) setUserLocale!: (userLocale: string) => void;
}
